<template>
  <div class="uk-card uk-card-small uk-box-shadow-small uk-card-default uk-margin-bottom">
    <div
      v-if="vehicle.inCart"
      class="uk-overlay-default uk-position-cover"
      style="z-index:10"
    ></div>
    <div class="uk-card-header">
      <div class="uk-card-badge uk-visible@l">
        <span class="uk-label uk-label-warning uk-text-small">{{ vehicle.currentstatus }}</span>
        <span v-if="tenant.knumber !== 'K10122' && tenant.knumber !== 'K10151'" class="uk-label uk-label-success uk-text-small uk-margin-small-left">{{ delivery }}</span>
      </div>
      <h3 class="uk-card-title uk-margin-remove uk-text-truncate uk-width-3-4@m">
        <router-link
          :to="{ name: 'vehicle-details', params: { id: vehicle.carId } }"
          class="uk-link-reset"
        >
          {{ name }}
        </router-link>
      </h3>
      <div class="uk-text-small uk-flex uk-flex-between uk-flex-wrap">
        Fahrzeug-Nr. {{ vehicle.carId }}
        <template v-if="(tenant.knumber === 'K10122' || tenant.knumber === 'K10151') && vehicle.origin"> <!-- fleetpool only -->
          | Standort: {{ vehicle.origin }}
        </template>
        <template v-else>
          <template v-if="showLocation && vehicle.location"> | Standort: {{ vehicle.location }}</template>
        </template>
        <span class="uk-label uk-label-warning uk-text-small uk-hidden@l">{{
          vehicle.currentstatus
        }}</span>
      </div>
      <span v-if="tenant.knumber !== 'K10122' && tenant.knumber !== 'K10151'" class="uk-label uk-label-success uk-text-small uk-hidden@l">{{ delivery }}</span>
    </div>
    <div class="uk-card-body">
      <div class="uk-grid" uk-grid>
        <div class="uk-width-1-5@l" v-if="showImages">
          <router-link
            :to="{ name: 'vehicle-details', params: { id: vehicle.carId } }"
            class="uk-link-reset"
          >
            <img
              v-if="vehicle.images && vehicle.images.length"
              :src="vehicle.images[0]['600']"
              :alt="name"
            />
            <img class="uk-width-1-1" v-else src="/img/placeholder.png" :alt="name" />
          </router-link>
          <router-link
            :to="{ name: 'vehicle-details', params: { id: vehicle.carId } }"
            class="uk-button uk-button-secondary uk-margin uk-width-1-1 uk-button-small"
          >
            Details und Bilder
          </router-link>
        </div>
        <div class="uk-width-expand@m">
          <div class="uk-grid uk-grid-match uk-grid-small uk-grid-divider" uk-grid>
            <div class="uk-width-1-5@l uk-width-1-3@m uk-text-small">
              <ul class="uk-list">
                <li class="uk-margin-remove">
                  {{ vehicle.internalfirstregdate || vehicle.firstregdate }}
                </li>
                <li class="uk-margin-remove">{{ vehicle.truemileage }} km</li>
                <li class="uk-margin-remove">
                  {{ vehicle.powerkw }} kW ({{ vehicle.powerps }} PS | {{ vehicle.fueltype }})
                </li>
                <li class="uk-margin-remove">{{ vehicle.transmission }}</li>
                <li class="uk-margin-remove">{{ vehicle.color }}</li>
                <li class="uk-margin-remove">
                  <span v-if="vehicle.tax">inkl. MwSt.</span>
                  <span v-else>MwSt. nicht ausweisbar</span>
                </li>
              </ul>
            </div>
            <div class="uk-width-1-5@l uk-width-1-3@m uk-width-1-2@s uk-text-small">
              <ul class="uk-list">
                <li class="uk-margin-remove">
                  {{ vehicle.category }}
                </li>
                <li class="uk-margin-remove">{{ vehicle.ccm }} ccm</li>
                <li class="uk-margin-remove" v-if="vehicle.cylinder && parseInt(vehicle.cylinder) > 0">
                  {{ vehicle.cylinder }} Zylinder
                </li>
                <li class="uk-margin-remove">{{ vehicle.doors }} Türen</li>
                <li class="uk-margin-remove">{{ vehicle.seats }} Sitze</li>
                <li class="uk-margin-remove">
                  <span v-if="vehicle.hsn">{{ vehicle.hsn }}</span
                  ><span v-if="vehicle.tsn"> / {{ vehicle.tsn }}</span>
                </li>
              </ul>
            </div>
            <div class="uk-width-1-5@l uk-width-1-3@m uk-width-1-2@s uk-text-small">
              <ConsumptionList :vehicle="vehicle" />
            </div>
            <div class="uk-width-expand@l uk-text-small">
              <component :is="pricesCardLayout" :vehicle="vehicle" />
              <hr class="uk-margin-small">
              <p
                class="uk-margin-remove-top uk-text-bold" style="padding: 0 10px;"
                v-if="(tenant.knumber === 'K10122' || tenant.knumber === 'K10151' || tenant.knumber === 'K10149') && vehicle.opendamages > 0"
              >
                Minderwert lt. Zustandsbericht: {{ vehicle.opendamages | euro }}
              </p>
              <p
                class="uk-margin-remove uk-text-xsmall" style="padding: 0 10px;"
                v-if="vehicle.newprice && showNewPrice"
              >
                {{ newpriceInfoLabel }}
              </p>
            </div>
            <div class="uk-width-1-1" v-if="vehicle.reserved">
              <div class="uk-flex uk-flex-right">
                <span class="uk-icon" style="color: #0891b2;">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                  <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd" />
                </svg>
                &nbsp;Fahrzeug reserviert!
                </span>
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="uk-card-footer">
      <div class="uk-flex uk-flex-between uk-flex-wrap">
      <button
        class="uk-button uk-button-secondary uk-button-small uk-visible@s"
        :uk-toggle="
          `target: .car-${vehicle.id}; animation: uk-animation-fade uk-animation-slide-top-small`
        "
      >
        <span :class="'car-' + vehicle.id" data-uk-icon="icon:triangle-down; ratio:1.2"></span>
        <span :class="'car-' + vehicle.id" data-uk-icon="icon:triangle-up; ratio:1.2" hidden></span>

        mehr
      </button>
      <div class="uk-flex uk-margin-remove">
        <cart-history-modal 
          v-if="showCartHistory && cartHistory && cartHistory.length" 
          :history="cartHistory" 
          :currently-in-cart="vehicle.inCart">
        </cart-history-modal>
        <offer-modal
          :vehicle="vehicle"
          class=" uk-inline uk-margin-small-right"
          size="small"
        ></offer-modal>
        <!--<button class="uk-button uk-button-secondary uk-button-small"><span class="uk-margin-small-right uk-icon" uk-icon="icon: bookmark"></span>Parken</button>
                        <button class="uk-button uk-button-secondary uk-button-small"><span class="uk-margin-small-right uk-icon" uk-icon="icon: table"></span>vergleichen</button>
                        <button class="uk-button uk-button-secondary uk-button-small"><span class="uk-margin-small-right uk-icon" uk-icon="icon: mail"></span>Anfragen</button>
                        <button class="uk-button uk-button-secondary uk-button-small"><span class="uk-margin-small-right uk-icon" uk-icon="icon: clock"></span>Reservieren</button>-->
        <add-to-cart
          :vehicle-id="vehicle.id"
          vehicle-name="name"
          size="uk-button-small"
          @added="onCartAdded"
          v-if="showCart"
        ></add-to-cart>
      </div>
      </div>
      <vehicle-description
        :vehicle="vehicle"
        :class="`car-${vehicle.id}`"
        hidden
      ></vehicle-description>
    </div>
    <modal ref="addToCartModal">
      <div class="uk-modal-header">
        <h2 class="uk-text-large">
          Zum Warenkorb hinzufügen
        </h2>
      </div>
      <div class="uk-modal-body" v-if="modalData">
        <p class="uk-margin">
          Das Fahrzeug
          <strong>{{ modalData.make }} {{ modalData.model }} {{ modalData.edition }}</strong>
          wurde in den Warenkorb gelegt
        </p>
      </div>
      <div class="uk-modal-footer uk-text-right">
        <button
          class="uk-button uk-button-default uk-modal-close uk-margin-small-right"
          type="button"
        >
          Zurück zur Liste
        </button>
        <a href="#" @click.prevent="goToCart" class="uk-button uk-button-primary">Zum Warenkorb</a>
      </div>
    </modal>
  </div>
</template>
<script>
import AddToCart from '@/components/vehicles/AddToCart'
import OfferModal from '@/components/vehicles/OfferModal.vue'
import Modal from '@/components/Modal'
import VehicleDescription from '@/components/vehicles/VehicleDescription'
import { mapGetters } from 'vuex'
import moment from 'moment'
import CartHistoryModal from './CartHistoryModal.vue'
import VehicleService from '@/services/vehicle.service'
import ConsumptionList from './ConsumptionList.vue'
export default {
  props: {
    vehicle: {
      required: true
    }
  },
  data() {
    return {
      modalData: null,
      cartHistory: null,
      hideLocation : ['K10170','K10139','K10179']
    }
  },
  components: {
    AddToCart,
    Modal,
    OfferModal,
    VehicleDescription,
    PricesCardFleetpool: () => import("@/components/vehicles/PricesCardFleetpool"),
    PricesCardBruening: () => import("@/components/vehicles/PricesCardBruening"),
    PricesCardPav: () => import("@/components/vehicles/PricesCardPav"),
    PricesCardDaLeo: () => import("@/components/vehicles/PricesCardDaLeo"),
    PricesCardMobCon: () => import("@/components/vehicles/PricesCardMobCon"),
    PricesCardDefault: () => import("@/components/vehicles/PricesCardDefault"),
    CartHistoryModal,
    ConsumptionList
  },
  mounted() {
    if(this.$store.state.auth.user.isAdmin && this.showCartHistory) {
      this.getCartHistory()
    }
  },
  computed: {
    ...mapGetters([
      'mode',
      'customerTypeLabel',
      'modeLabel',
      'modePriceLabel',
      'showEndcustomerPrices',
      'showMerchantPrices',
      'tenant',
      'merchantConfig',
      'config'
    ]),
    name() {
      return `${this.vehicle.make} ${this.vehicle.model} ${this.vehicle.edition}`
    },
    pricesCardLayout() {
      if (this.tenant && (this.tenant.knumber === 'K10122' || this.tenant.knumber === 'K10151')) {
        return 'PricesCardFleetpool'
      }
      if (this.tenant && this.tenant.knumber === 'K10149') {
        return 'PricesCardBruening'
      }
      if (this.tenant && this.tenant.knumber === 'K10140') {
        return 'PricesCardPav'
      }
      if (this.tenant && this.tenant.knumber === 'K10162') {
        return 'PricesCardDaLeo'
      }
      if (this.tenant && this.tenant.knumber === 'K10170') {
        return 'PricesCardMobCon'
      }
      return 'PricesCardDefault'
    },
    newpriceInfoLabel() {
      if(this.pricesCardLayout !== 'PricesCardBruening' && this.tenant.knumber !== 'K10179') {
        if (this.tenant && (this.tenant.knumber === 'K10122' || this.tenant.knumber === 'K10151')) {
          return '*Ehem. Listenneupreis des Herstellers zum Zeitpunkt der Erstzulassung inklusive Werks-Frachtkostenpauschale (netto 500,-). Werte ohne Gewähr'
        }
        return '*Listenneupreis des Herstellers. Werte ohne Gewähr'
      }
      return ''
    },
    showImages() {
      if(this.mode !== 'merchant' && (this.merchantConfig && this.merchantConfig.general && this.merchantConfig.general.hideImages)) {
        return false
      }

      return true
    },
    delivery() {
      const date = moment()
      const formatedDate = date.format('YYYY-MM-DD')
      let output = ''
      let compareDate = this.vehicle.deliverydate
      if(this.tenant.knumber === 'K10149') { // Brüning
        compareDate = this.vehicle.deRegistrationDate
      }
      if (compareDate && compareDate <= formatedDate) {
        output = 'Sofort lieferbar'
      } else if (compareDate > formatedDate) {
        const deliveryDate = moment(compareDate)
        //let days = Math.ceil(date.diff(deliveryDate, 'days') / 7).toString()
        let days = Math.ceil(date.diff(deliveryDate, 'days')).toString()
        if (days.includes('-')) {
          days = days.replace('-', '')
        }
        //output = parseInt(days) === 1 ? '1 Woche' : days + ' Wochen'
        output = parseInt(days) <= 1 ? '1 Tag' : days + ' Tage'
      } else if (!compareDate && this.vehicle.deliveryperiod !== 'KEINE' && this.vehicle.deliveryperiod !== '') {
        /*
        const days = Math.ceil(this.vehicle.deliveryperiod / 7)
        output = days === 1 ? '1 Woche' : days + ' Wochen'
        */
        const days = Math.ceil(this.vehicle.deliveryperiod)
        output = days <= 1 ? '1 Tag' : days + ' Wochen'
      } else {
        output = 'Sofort lieferbar'
      }

      return output
    },
    showCart() {
      if(this.config.general && this.config.general.disableCart) {
        return false
      }
      return true
    },
    showCartHistory() {
      return this.tenant && (this.tenant.knumber === 'K10122' || this.tenant.knumber === 'K10151') 
    },
    showNewPrice() {
      return this.tenant && this.tenant.knumber !== 'K10137' 
    },
    showLocation() {
      return this.tenant && !this.hideLocation.includes(this.tenant.knumber)
    }
  },
  methods: {
    async getCartHistory() {
      const response = await VehicleService.getCartHistory(this.vehicle.carId)
      this.cartHistory = response.data
    },
    onCartAdded(data) {
      this.modalData = data
      this.$refs.addToCartModal.open()
    },
    goToCart() {
      this.$refs.addToCartModal.close()
      this.$router.push({
        name: 'cart'
      })
    }
  }
}
</script>
